import { Card } from '../../../../components/ui/card';
import { DollarSign, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function CajaContainer({ data }) {
  const navigate = useNavigate();

  return (
    <Card 
      className="p-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors cursor-pointer"
      onClick={() => navigate('/caja')}
    >
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-green-500" />
            <h2 className="text-lg font-semibold">Resumen de Caja</h2>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Efectivo</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.efectivo.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Transferencias</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.transferencias.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Crédito</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.credito.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Otros</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.otros.toLocaleString()}</div>
          </div>
          <div className="pt-2 border-t dark:border-gray-700">
            <div className="flex justify-between items-center text-red-600 dark:text-red-400">
              <div className="text-sm">Pendiente de cobro</div>
              <div className="font-medium">
                ${data.pendiente.monto.toLocaleString()} ({data.pendiente.ventas} {data.pendiente.ventas === 1 ? 'venta' : 'ventas'})
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
} 